<template>
  <div id="map">
    <div class="title">
      <div class="icon"></div>
      <div class="logo"></div>
    </div>
    <div class="can_con">
      <div id="qtcanvas"></div>
      <!-- 兴趣点 -->
      <transition name="fade">
        <div class="hello test-1" v-show="isActiveTool == 'xinQu'">
          <div v-for="(users, i) in userList" :key="i">
            <div class="hi" :class="{ active: isHoverTool == users.Name }">
              <img
                :src="users.src"
                @click="flyToPoint(users)"
                @mouseenter="setActive(users.Name)"
                @mouseleave="cleanActive"
              />
            </div>
            <div class="usersName">{{ users.Name }}</div>
          </div>
        </div>
      </transition>
      <div class="btn">
        <button
          v-for="(k, i) in toolList"
          :key="i"
          :title="k.title"
          :id="'btn-' + k.id"
          @mouseenter="setActive(k.id)"
          @mouseleave="cleanActive()"
          :class="{ active: isHoverTool === k.id || k.state }"
          @click="setToolClickEvent(k)"
        ></button>
        <!-- 定位功能 -->
        <transition name="fade">
          <div class="pop" v-show="isActiveTool == 'location'">
            <div style="height: 3.5rem; width: 100%">
              <button class="back" @click="goBack"></button>
            </div>
            <label
              >经度值
              <input
                type="number"
                v-model="lon"
                placeholder="输入经度："
                style="color: #000"
            /></label>
            <label
              >纬度值
              <input
                type="number"
                v-model="lat"
                placeholder="输入纬度："
                style="color: #000"
            /></label>
            <button
              class="location"
              @click="location()"
              style="font-size: 1.6rem"
            >
              定位
            </button>
          </div>
        </transition>
        <!-- 测量功能 -->
        <transition name="fade">
          <div class="measure" v-show="isActiveTool == 'measure'">
            <measure id="measure" ref="measure"></measure>
          </div>
        </transition>
      </div>
      <!-- 移动按键 -->
      <div class="btn1">
        <div class="circle">
          <img src="../assets/icon/内环.png" alt="移动" />
          <img
            id="rotate"
            src="../assets/icon/compass.png"
            alt="指北针"
            :style="{
              transform: 'translate(-50%,-50%)' + ' Rotate(' + angle + 'deg)'
            }"
          />
          <button
            v-for="(k, i) in fun_name"
            :key="i"
            :id="k.id"
            :style="{
              backgroundImage: 'url(' + (k.state == 0 ? k.src : k.src1) + ')'
            }"
            @touchstart.prevent="wasm_fun(k)"
            @touchend.prevent="End(k)"
            @mousedown.prevent="wasm_fun(k)"
            @mouseup.prevent="End(k)"
            @mouseenter="k.state = 1"
            @mouseleave="k.state = 0"
          ></button>
        </div>
        <div class="zoom"></div>
      </div>
      <div class="version">版本号：{{ version }}</div>
    </div>
    <div id="loading" v-if="loading_state">
      <div class="border">
        <div class="bar" :style="{ width: width + '%' }">&nbsp;</div>
        <div class="desc">{{ msg }}</div>
        <div class="tip">易景地球</div>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
const measure = () => import("./measure.vue");
export default {
  name: "HelloWorld",
  components: { measure },
  data() {
    return {
      fun_name: [
        {
          name: "CameraController_LookUp",
          id: "turn-up",
          active: "turn_up",
          src: require("../assets/icon/turn_up.png"),
          src1: require("../assets/icon/turn_up1.png"),
          state: 0
        },
        {
          name: "CameraController_Forward",
          id: "up",
          active: "up",
          src: require("../assets/icon/up.png"),
          src1: require("../assets/icon/up1.png"),
          state: 0
        },
        {
          name: "CameraController_LeftRoll",
          id: "turn-left",
          active: "turn_left",
          src: require("../assets/icon/turn_left.png"),
          src1: require("../assets/icon/turn_left1.png"),
          state: 0
        },
        {
          name: "CameraController_LeftMove",
          id: "left",
          active: "left",
          src: require("../assets/icon/left.png"),
          src1: require("../assets/icon/left1.png"),
          state: 0
        },
        {
          name: "CameraController_RightMove",
          id: "right",
          active: "right",
          src: require("../assets/icon/right.png"),
          src1: require("../assets/icon/right1.png"),
          state: 0
        },
        {
          name: "CameraController_RightRoll",
          id: "turn-right",
          active: "turn_right",
          src: require("../assets/icon/turn_right.png"),
          src1: require("../assets/icon/turn_right1.png"),
          state: 0
        },
        {
          name: "CameraController_Back",
          id: "down",
          active: "down",
          src: require("../assets/icon/down.png"),
          src1: require("../assets/icon/down1.png"),
          state: 0
        },
        {
          name: "CameraController_LookDown",
          id: "turn-down",
          active: "turn_down",
          src: require("../assets/icon/turn_down.png"),
          src1: require("../assets/icon/turn_down1.png"),
          state: 0
        },
        {
          name: "CameraController_Descend",
          id: "enlarge",
          active: "enlarge",
          src: require("../assets/icon/fangda.png"),
          src1: require("../assets/icon/fangda1.png"),
          state: 0
        },
        {
          name: "CameraController_Raise",
          id: "shrink",
          active: "shrink",
          src: require("../assets/icon/suoxiao.png"),
          src1: require("../assets/icon/suoxiao1.png"),
          state: 0
        }
      ],
      toolList: [
        {
          id: "xinQu",
          title: "兴趣点",
          state: false,
          isOnly: true
        },
        {
          id: "measure",
          title: "测量",
          state: false,
          isOnly: true
        },
        {
          id: "location",
          title: "定位",
          state: false,
          isOnly: true
        },
        {
          id: "surround",
          title: "环绕飞行",
          state: false,
          isOnly: false
        },
        {
          id: "copy",
          title: "坐标复制",
          state: false,
          isOnly: true
        }
      ], // 功能列表
      oldLntLat: {},
      isHoverTool: "",
      isActiveTool: "",
      nowActiveToolObj: {}, // 当前激活工具对象
      isCopy: false,
      msg: "正在下载中...",
      loading_state: true,
      userList: [],
      LookAt: [],
      lon: 0,
      lat: 0,
      alt: 0,
      tilt: 0,
      header: 0,
      time: 0,
      lo_alt: "",
      ca_alt: "",
      width: 0,
      version: "",
      angle: 0,
      kml_layer: ""
    };
  },
  methods: {
    load() {
      this.getUserList();
      let asm = window.Module.asm;
      let root = asm.Scene_RootFolder();
      let kmlLayer = asm.Folder_AddKmlLayer(root);
      this.kml_layer = asm.ContainerImpl_GetFeatures(
        asm.EvEarthKmlLayer_GetKmlLayer(kmlLayer)
      );

      // 加载大潘庄矢量数据
      this.axios.get(config.DPZJson).then(res => {
        let geojson = res.data;
        geojson.features.forEach(item => {
          window.Module.asm.Scene_BeginTempPolyline(
            0xffff0000,
            5,
            0xffffffff,
            5,
            false
          );
          item.geometry.coordinates[0].forEach(v => {
            window.Module.asm.Scene_AddTempPolyline(v[0], v[1], 10);
          });
          window.Module.asm.Scene_EndTempPolyline();
        });
      });
    },
    async init() {
      let that = this;
      const instance = await qtLoad({
        qt: {
          onLoaded: () => {},
          onExit: exitData => {
            that.width = 40;
            that.msg = "正在加载中...";
            clearInterval(that.timer);
            that.timer_num = setInterval(() => {
              if (that.width >= 90) {
                clearInterval(that.timer_num);
              } else {
                that.width += 10;
              }
            }, 1000);
          },
          entryFunction: window.createQtAppInstance,
          containerElements: [document.querySelector("#qtcanvas")]
        }
      });
      window.Module = instance;
      that.width = 100;
      clearInterval(that.timer_num);
      setTimeout(() => {
        window.Module.asm.LoadFont(that.allocate(config.fontUrl));
        that.loading_state = false;
      }, 1000);
      window.Module.asm.Scene_Navigate(that.allocate(config.sceneUrl));
      window.Module.asm.GuidePlane_SetVisible(
        window.Module.asm.Scene_GetGuidePlane(),
        false
      );
    },
    // wasm 转 js
    UTF8ToString(addr) {
      let mbuffer = window.Module.asm.memory.buffer;
      let buffer = new Uint8Array(mbuffer, addr, mbuffer.byteLength - addr);
      let term = buffer.indexOf(0);
      return new TextDecoder().decode(buffer.subarray(0, term));
    },
    // js 转wasm识别
    allocate(str) {
      let jsonstr1 = Array.from(new TextEncoder().encode(str)).concat(0);
      const ptr = window.Module.asm.malloc(jsonstr1.length);
      window.Module.HEAPU8.set(jsonstr1, ptr);
      return ptr;
    },
    compass() {
      let head = window.Module.asm.CameraController_GetHeading();
      this.angle = head * 1;
    },
    StopFocus() {
      document.activeElement.blur();
    },
    setToolClickEvent(obj) {
      if (obj.isOnly) {
        console.log("🚀 ~ map.vue:340 ~ obj:", obj);
        if (obj.state) {
          this.clearTool();
        } else {
          this.clearTool();
          this.openToolPop(obj);
        }
      } else {
        this[obj.id + "Open"](obj);
      }
    },
    clearTool() {
      if (this.nowActiveToolObj.state) {
        this.openToolPop(this.nowActiveToolObj);
      }
    },
    openToolPop(obj) {
      obj.state = !obj.state;
      if (obj.state) {
        this.nowActiveToolObj = obj;
        this.$refs.measure.btn_click();
        this.isActiveTool = obj.id;
        window.Module.asm.ObjectContainerImpl_ClearChild(this.kml_layer);
        if (obj.id == "measure") {
          this.$store.state.mea_state = obj.state;
        }
        // 开启坐标复制功能
        else if (obj.id == "copy") {
          this.isCopy = obj.state;
          this.$message({
            message: "请在地图上点击进行复制经纬度！",
            type: "success",
            duration: 4000
          });
        }
      } else {
        window.Module.asm.ObjectContainerImpl_ClearChild(this.kml_layer);

        this.nowActiveToolObj = {};
        this.isActiveTool = "";
        this.$store.state.mea_state = false;
        this.isCopy = false;
      }
    },
    // 开启环绕飞行功能
    surroundOpen() {
      let LookAt = window.Module.asm.Scene_GetLookAt();
      window.Module.asm.CameraController_Surround(
        window.Module.asm.LookAt_GetLongitude(LookAt),
        window.Module.asm.LookAt_GetLatitude(LookAt),
        window.Module.asm.LookAt_GetAltitude(LookAt),
        2,
        window.Module.asm.CameraController_GetAltitude(),
        window.Module.asm.LookAt_GetRange(LookAt)
      );
    },
    goBack() {
      window.Module.asm.ObjectContainerImpl_ClearChild(this.kml_layer);
      this.isActiveTool = "";
    },
    location() {
      let asm = window.Module.asm;
      asm.ObjectContainerImpl_ClearChild(this.kml_layer);
      let curPath = window.document.location.href;
      let pos = curPath.indexOf("#");
      let IconUrl = curPath.substring(0, pos) + "static/marker.png";
      asm.ObjectContainerImpl_AddPoint(
        this.kml_layer,
        this.lon,
        this.lat,
        100,
        allocate(this.lon + "," + this.lat),
        allocate(IconUrl)
      );
      // 跳转
      asm.CameraController_FlyTo(this.lon, this.lat, 10000, 0, 0, 2);
    },
    flyToPoint(user) {
      window.Module.asm.CameraController_FlyTo(
        user.lon,
        user.lat,
        user.alt,
        user.tilt,
        user.head,
        2
      );
    },
    wasm_fun(fun) {
      this.Polling = setInterval(() => {
        window.Module.asm[fun.name]();
        fun.state = 2;
      }, 100);
    },
    setActive(fun) {
      this.isHoverTool = fun;
    },
    cleanActive() {
      this.isHoverTool = "";
    },
    End(fun) {
      clearInterval(this.Polling);
      fun.state = 1;
    },
    getUserList() {
      let that = this;
      this.axios.get("./static/data.json").then(rest => {
        //用axios的方法引入地址
        that.userList = rest.data.result;
      });
    },
    copyCoordinate(text) {
      let clipboard = new Clipboard("#qtcanvas", {
        text: () => {
          return text;
        }
      });
      clipboard.on("success", e => {
        this.$message({ message: "复制成功！", type: "success" });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        this.$message({ message: "复制失败", type: "error" });
        // 释放内存
        clipboard.destroy();
      });
      this.isCopy = false;
      this.toolList.find(v => v.id == "copy").state = false;
    }
  },
  mounted() {
    window.UTF8ToString = this.UTF8ToString;
    window.allocate = this.allocate;
    if (sessionStorage.getItem("token")) {
      this.init();
      let that = this;
      window.OnLButtonDown = (x, y) => {
        this.oldLntLat = { x: x, y: y };
      };
      window.OnLButtonUp = (x, y) => {
        if (this.oldLntLat.x == x && this.oldLntLat.y == y) {
          let PixelScale = window.Module.asm.Scene_PixelScale();
          let S_Vec3Geo = window.Module.asm.Scene_WinToBL(
            x * PixelScale,
            y * PixelScale
          );
          let go_x = window.Module.asm.Geo_x(S_Vec3Geo).toFixed(6);
          let go_z = window.Module.asm.Geo_z(S_Vec3Geo).toFixed(6);
          window.Module.asm.Geo_Delete(S_Vec3Geo);
          if (this.isCopy) {
            // let coordinate = `经度:${go_x},纬度:${go_z}`
            let coordinate = `${go_x},${go_z}`;
            this.copyCoordinate(coordinate);
          }
          if (that.$store.state.mea_state) {
            // 测量开关打开
            that.$store.state.mea_fun(x, y);
          }
        }
      };
      window.OnSceneOpened = function(url) {
        that.load();
        let version = window.Module.asm.Version();
        that.version = UTF8ToString(version);
        setInterval(function() {
          that.compass();
        }, 500);
      };
    } else {
      this.$router.push("/");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#map {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .title {
    position: relative;
    // z-index: 100;
    background: url("../assets/map/top.png");
    width: 100%;
    height: 8rem;
    line-height: 100%;
    text-align: left;
    color: #fff;
    font-size: 30px;
    font-weight: 700;

    .icon {
      background: url("../assets/map/icon.png") 0rem 0rem no-repeat;
      position: absolute;
      height: 6rem;
      width: 6rem;
      margin-top: 1rem;
      background-size: 100% 100%;
      margin-left: 3rem;
    }

    .logo {
      background: url("../assets/map/logo.png");
      background-size: 100% 100%;
      position: absolute;
      height: 4.8rem;
      width: 30.4rem;
      top: 1.6rem;
      left: 11rem;
    }
  }
}

.can_con {
  position: relative;
  width: 100%;
  background-color: #000;
  height: calc(100% - 8rem);

  .hello {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    width: 29rem;
    z-index: 100;
    height: calc(100% - 300px);
    position: absolute;
    background: url("../assets/map/menu.png");
    padding: 3rem 0rem 3rem 0rem;
    border: 0.1rem solid;
    overflow: auto;
    left: 10rem;
    top: 3rem;
    color: #2c3e50;
    background-size: 100% 100%;

    .hi,
    img {
      width: 19rem;
      height: 13rem;
    }

    .hi {
      margin-left: 5rem;
    }

    .active {
      box-shadow: 0 0 9px 3px #fff;
    }

    .usersName {
      color: #fff;
      margin: 1rem;
    }
  }

  .test-1::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 1rem;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 0.1rem;
  }

  .test-1::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    // border-radius: 1rem;
    box-shadow: inset 0 0 0.5rem rgba(0, 0, 0, 0.2);
    background: #535353;
  }

  .test-1::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 0.5rem rgba(0, 0, 0, 0.2);
    // border-radius: 1rem;
    background: rgba(11, 19, 51, 69%);
  }

  .fade-enter-active {
    transition: all 0.5s ease;
  }

  .fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .fade-enter,
  .fade-leave-to {
    transform: translateX(-50px);
    opacity: 0;
  }

  .btn {
    position: absolute;
    z-index: 100;
    width: 100%;
    height: 6rem;
    border: none;
    padding: 3rem 0 0 0;
    top: 0px;

    .active {
      box-shadow: 0 0 0.6rem 0.3rem #fff;
    }

    .pop {
      background-color: #2c3e50;
      position: absolute;
      border-radius: 1rem;
      top: 10rem;
      right: 0px;
      width: 30rem;
      height: 20rem;
      text-align: center;
      color: rgb(255, 255, 255);
      z-index: 9;

      .back {
        position: absolute;
        top: 0.4rem;
        right: 0.4rem;
        height: 2.6rem;
        width: 2.6rem;
        background: url("../assets/map/back.png");
        background-size: 100% 100%;
      }

      label {
        margin: 0 0 0.5rem 0;
        display: block;
        height: 3.3rem;
        width: 30rem;
        font-size: 2rem;
        position: relative;
        margin: 0 auto;
        margin-bottom: 2rem;
      }

      input {
        border-radius: 0.8rem;
        height: 3rem;
        width: 18rem;
        padding: 0;
        border: none;
        padding-left: 3rem;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        appearance: none;
      }

      input[type="number"] {
        -moz-appearance: textfield;
        appearance: textfield;
      }

      button {
        width: 10rem;
        height: 3rem;
        color: #fff;
        margin-left: 2rem;
        background-color: #2683cce1;
        border-radius: 0.8rem;
      }

      p {
        font-size: 14px;
        font-weight: 600;
      }
    }

    .measure {
      width: 30rem;
      padding: 1rem;
      position: absolute;
      top: 10rem;
      right: 0px;
      color: #fff;
      box-sizing: border-box;
      border-radius: 5px;
      border: 1px solid #186d90;
      background-color: rgba(8, 56, 83, 0.8);
      overflow: initial;

      // &::before {
      //   content: '';
      //   width: 12rem;
      //   // background: url('../../../assets/forest/right/border.png') no-repeat 0 0;
      //   background-size: 100% 100%;
      //   height: 5px;
      //   position: absolute;
      //   bottom: -3px;
      //   left: 100px;
      // }
    }

    button {
      width: 5rem;
      height: 5rem;
      border: none;
      cursor: pointer;
    }

    #btn-xinQu {
      background: url("../assets/map/xinQu.png") no-repeat;
      margin-left: 3rem;
      float: left;
      background-size: 100% 100%;
    }

    #btn-location,
    #btn-surround,
    #btn-copy,
    #btn-measure {
      float: right;
      margin-right: 3rem;
      border-radius: 8px;
    }

    #btn-location {
      background: url("../assets/map/location.png") no-repeat;
      background-size: 100% 100%;
    }

    #btn-surround {
      background: url("../assets/map/surround.png") no-repeat;
      background-size: 100% 100%;
    }

    #btn-copy {
      background: url("../assets/map/copy.png") no-repeat;
      background-size: 100% 100%;
      border: 1px #2a9ea6 solid;
      background-color: #00051f;
    }

    #btn-measure {
      background: url("../assets/map/measure.png") no-repeat;
      background-size: 100% 100%;
      border: 1px #2a9ea6 solid;
      background-color: #00051f;
    }
  }

  // 移动按键
  .btn1 {
    width: 66px;
    height: 150px;
    position: absolute;
    z-index: 100;
    bottom: 30px;
    right: 30px;
    background: rgba(0, 0, 0, 0);

    // z-index: 9;
    .circle {
      height: 66px;
      width: 66px;
      position: absolute;
      background: url("../assets/icon/circle_bg.png") no-repeat;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .zoom {
      width: 34px;
      height: 68px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      background: url("../assets/icon/zoom.png");

      img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    button {
      border: none;
      padding: 0;
    }

    #turn-up {
      width: 13px;
      height: 7px;
      top: 5px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
    }

    #turn-down {
      width: 13px;
      height: 7px;
      bottom: 5px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
    }

    #turn-right {
      width: 8px;
      height: 26px;
      right: 5px;
      top: 50%;
      position: absolute;
      transform: translateY(-50%);
    }

    #turn-left {
      width: 8px;
      height: 26px;
      left: 5px;
      top: 50%;
      position: absolute;
      transform: translateY(-50%);
    }

    #left {
      width: 6px;
      height: 6px;
      left: 19px;
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      background-size: 100% 100%;
    }

    #right {
      width: 6px;
      height: 6px;
      right: 19px;
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      background-size: 100% 100%;
    }

    #up {
      width: 6px;
      height: 6px;
      top: 19px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      background-size: 100% 100%;
    }

    #down {
      width: 6px;
      height: 6px;
      bottom: 19px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      background-size: 100% 100%;
    }

    #enlarge {
      width: 16px;
      height: 16px;
      top: 90px;
      left: 50%;
      position: absolute;
      transform: translateX(-50%);
      background-size: 100% 100%;
      z-index: 1;
    }

    #shrink {
      width: 16px;
      height: 16px;
      top: 125px;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      background-size: 100% 100%;
      z-index: 1;
    }
  }
}

.version {
  position: absolute;
  z-index: 100;
  bottom: 35px;
  left: 0rem;
  color: #fff;
}

#qtcanvas {
  border: 0px none;
  height: 100%;
  width: 100%;
}

#loading {
  position: absolute;
  top: 8rem;
  left: 0;
  z-index: 1000;
  color: #fff;
  // background-color: rgba(153, 153, 153, 0.5);
  background-color: rgb(36, 24, 24);
  // background-color: #fff;
  height: calc(100% - 8rem);
  width: 100%;

  .border {
    border: 0.1rem solid #777;
    width: 27.5rem;
    height: 1.4rem;
    padding: 0.1rem;
    position: absolute;
    left: 50%;
    top: 50%;
    border-radius: 0.7rem;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
  }

  .bar {
    background-color: #73c944;
    width: 50%;
    height: 1.4rem;
    border-radius: 0.6rem;
    overflow: hidden;
  }

  .desc {
    text-align: center;
    font-size: 12px;
    line-height: 2.4rem;
  }

  .tip {
    text-align: center;
    font-size: 20px;
    line-height: 2.4rem;
    position: relative;
    font-weight: 800;
    top: -7rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/map.vue